import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import ImageLoader from "../images/ImageLoader";
import PegIcon from "../../images/svg/peg-icon.svg";
import PegStar from "../../images/svg/peg-star.svg";
import CircleInactive from "../../images/svg/circle-inactive.svg";
import QrCode from "../../images/svg/qr-code.svg";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import BonusGameTile from "../bonusGameTile/bonusGameTile";
import { getLoyaltyStorage } from "../../util";
import { LoyaltyAccountStatus } from "../../util/LoyaltyAccountStatus";
import { connect } from 'react-redux';

var PegProgressBar = function PegProgressBar(props) {
  var _bonusGameTile$, _props$loyalty2, _props$loyalty2$accou;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model;
  var image = model.image,
      rewardProgressCopy = model.rewardProgressCopy,
      memberId = model.memberId,
      balance = model.balance,
      _model$bonusGameTile = model.bonusGameTile,
      bonusGameTile = _model$bonusGameTile === void 0 ? {} : _model$bonusGameTile;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      balancePoints = _useState2[0],
      setBalancePoints = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      balanceLabel = _useState4[0],
      setBalanceLabel = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      ranges = _useState6[0],
      setRanges = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      progressPercentage = _useState8[0],
      setProgressPercentage = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      animatedCopy = _useState10[0],
      setAnimatedCopy = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      countUp = _useState12[0],
      setCountUp = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      pausedAccount = _useState14[0],
      setPausedAccount = _useState14[1];

  var fullRanges = [0, 75, 150, 225, 300, 375, 450, 500];
  var maxPegs = 500;
  var minPegsToShowLastBar = 375;
  var localBalance = 0;
  var position = 0;
  var bonusGameTileModel = (_bonusGameTile$ = bonusGameTile[0]) === null || _bonusGameTile$ === void 0 ? void 0 : _bonusGameTile$.fields;

  var getExcess = function getExcess() {
    var rangeDifference = fullRanges[position + 1] - fullRanges[position];
    var excess = (localBalance - fullRanges[position]) / rangeDifference;

    if (excess > 0 && excess < 0.3) {
      excess = 0.3;
    }

    return excess;
  };

  useEffect(function () {
    var _loyaltyStorage$accou, _props$loyalty, _props$loyalty$accoun;

    var loyaltyStorage = getLoyaltyStorage();

    if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused) {
      setPausedAccount(true);
      return;
    }

    localBalance = parseInt(((_props$loyalty = props.loyalty) === null || _props$loyalty === void 0 ? void 0 : (_props$loyalty$accoun = _props$loyalty.account) === null || _props$loyalty$accoun === void 0 ? void 0 : _props$loyalty$accoun.Balance) || 0);

    if (localBalance > maxPegs) {
      localBalance = maxPegs;
    }

    setBalancePoints(localBalance); // Storybook only

    if (props.storybookPegsBalance) {
      localBalance = parseInt(props.storybookPegsBalance || 0);

      if (localBalance > maxPegs) {
        localBalance = maxPegs;
      }

      setBalancePoints(localBalance);
    }

    fullRanges.forEach(function (range, index) {
      if (localBalance >= range && localBalance < fullRanges[index + 1]) {
        position = index;
      } else if (localBalance >= fullRanges[fullRanges.length - 1]) {
        position = fullRanges.length - 1;
      }
    });

    if (position < 2) {
      setRanges(fullRanges.slice(0, 5));
      setProgressPercentage((position + getExcess()) * 100 / 4);
    } else {
      setRanges(fullRanges.slice(0, position + 3));

      if (position + 3 > fullRanges.length - 1) {
        if (position === fullRanges.length - 1) {
          setProgressPercentage(100);
        } else {
          setProgressPercentage((position + getExcess()) * 100 / (fullRanges.length - 1));
        }
      } else {
        setProgressPercentage((position + getExcess()) * 100 / (position + 2));
      }
    }

    var start = 0;

    if (localBalance) {
      var timer = setInterval(function () {
        start += 10;

        if (start >= parseInt(localBalance)) {
          setCountUp(localBalance);
          clearInterval(timer);
        } else {
          setCountUp(start);
        }
      }, localBalance > 200 ? 20 : 50);
    } else {
      setCountUp(0);
    }

    if (rewardProgressCopy === null || rewardProgressCopy === void 0 ? void 0 : rewardProgressCopy.value) {
      setAnimatedCopy(rewardProgressCopy.value.replace("15", fullRanges[position]));
    }

    if (balance === null || balance === void 0 ? void 0 : balance.value) {
      setBalanceLabel(balance.value.replace("23", "").trim());
    }
  }, [(_props$loyalty2 = props.loyalty) === null || _props$loyalty2 === void 0 ? void 0 : (_props$loyalty2$accou = _props$loyalty2.account) === null || _props$loyalty2$accou === void 0 ? void 0 : _props$loyalty2$accou.Balance]);

  var showMemberIdModal = function showMemberIdModal() {
    var customEvent = new CustomEvent("openMemberIdModal", {});
    window.dispatchEvent(customEvent);
  };

  if (pausedAccount) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__image-container"
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: image,
    type: "product",
    className: "cb-peg-progress-bar__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__loyalty-balance-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__loyalty-id",
    onClick: showMemberIdModal
  }, /*#__PURE__*/React.createElement("img", {
    className: "cb-peg-progress-bar__loyalty-id__icon",
    src: QrCode,
    alt: "QR code"
  }), /*#__PURE__*/React.createElement("span", {
    className: "cb-peg-progress-bar__loyalty-id__copy"
  }, memberId === null || memberId === void 0 ? void 0 : memberId.value)), /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__balance-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__balance"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cb-peg-progress-bar__balance__text"
  }, countUp), /*#__PURE__*/React.createElement("img", {
    className: "cb-peg-progress-bar__balance__icon",
    src: PegIcon,
    alt: "Peg Icon"
  })), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: {
      value: balanceLabel
    },
    className: "cb-peg-progress-bar__balance-copy"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__progress-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__progress",
    style: {
      width: "".concat(progressPercentage, "%")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__progress-points-container"
  }, ranges.map(function (range, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "point-".concat(index),
      className: "cb-peg-progress-bar__progress-point"
    }, index != 0 && index != ranges.length - 1 && /*#__PURE__*/React.createElement("img", {
      className: "cb-peg-progress-bar__progress-point__circle",
      src: CircleInactive,
      alt: "Point"
    }), index === 0 && /*#__PURE__*/React.createElement("div", {
      className: "cb-peg-progress-bar__progress-point-start-end cb-peg-progress-bar__progress-point-start-end--orange"
    }), balancePoints >= minPegsToShowLastBar && index === ranges.length - 1 ? /*#__PURE__*/React.createElement("div", {
      className: "cb-peg-progress-bar__progress-point-start-end ".concat(progressPercentage === 100 ? "cb-peg-progress-bar__progress-point-start-end--orange" : "")
    }) : null);
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-progress-bar__peg-rewards-labels-container"
  }, parseInt(balancePoints) >= parseInt(ranges[1]) && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: {
      value: animatedCopy
    },
    className: "cb-peg-progress-bar__peg-rewards-copy"
  }), ranges.map(function (range, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "point-".concat(index),
      className: "cb-peg-progress-bar__peg-rewards-labels"
    }, /*#__PURE__*/React.createElement("span", {
      className: "cb-peg-progress-bar__peg-rewards-labels__label ".concat(index != 0 && index != ranges.length - 1 && range <= balancePoints ? "cb-peg-progress-bar__peg-rewards-labels__label--animated" : "")
    }, index != ranges.length - 1 ? range : " "), index != 0 && index != ranges.length - 1 && range <= balancePoints && /*#__PURE__*/React.createElement("img", {
      className: "cb-peg-progress-bar__peg-rewards-labels__star",
      src: PegStar,
      alt: "Point"
    }));
  })))), /*#__PURE__*/React.createElement(BonusGameTile, {
    model: bonusGameTileModel
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loyalty: state.loyalty
  };
};

export default connect(mapStateToProps, null)(PegProgressBar);